// extracted by mini-css-extract-plugin
export default {"card":"Approach_card__B0EdG","cardNumber":"Approach_cardNumber__p3Voa","cardTitle":"Approach_cardTitle__nVZge","cardBody":"Approach_cardBody__n26ce"};